/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'fabric.editor.chromeCollapsedPlaceholder': 'Escribe algo…',
  'fabric.editor.editorAssistiveLabel': 'Área de contenido principal, empieza a escribir para introducir texto.',
  'fabric.editor.headingLink.toolbarHelpTitle': 'Abrir diálogo de ayuda',
};
